module.exports = __webpack_public_path__ + "ptc_nakagawa_J1.8e2ed91d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_J1.jpg
// module id = w4PY
// module chunks = 0